import React from 'react';

const RANGES = [
  { value: 7, label: '7 Tage' },
  { value: 30, label: '30 Tage' },
  { value: 90, label: '90 Tage' },
  { value: 'all', label: 'Alle' }
];

export function StatFilters({ templates, templateName, onTemplateChange, rangeDays, onRangeChange }) {
  return (
    <div className="flex flex-wrap items-end gap-4 mb-6">
      <div>
        <label htmlFor="stat-vorlage" className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">Vorlage</label>
        <select
          id="stat-vorlage"
          aria-label="Vorlage"
          value={templateName}
          onChange={(e) => onTemplateChange(e.target.value)}
          className="rounded-xl border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-sm text-slate-800 dark:text-slate-100 px-3 py-2"
        >
          <option value="all">Alle Vorlagen</option>
          {templates.map(t => <option key={t} value={t}>{t}</option>)}
        </select>
      </div>
      <div>
        <span className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">Zeitraum</span>
        <div className="inline-flex rounded-xl border border-slate-300 dark:border-slate-600 overflow-hidden">
          {RANGES.map(r => {
            const active = rangeDays === r.value;
            return (
              <button
                key={String(r.value)}
                type="button"
                onClick={() => onRangeChange(r.value)}
                className={`px-3 py-2 text-sm ${active
                  ? 'text-white font-medium'
                  : 'bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200'}`}
                style={active ? { backgroundColor: '#0891b2' } : undefined}
              >
                {r.label}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
